import { render, staticRenderFns } from "./WordToFbdPage.vue?vue&type=template&id=f16d87f0"
import script from "./WordToFbdPage.vue?vue&type=script&lang=ts"
export * from "./WordToFbdPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports